import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-996220c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-screen flex flex-column justify-content-center align-content-center align-items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "my-4 text-xl font-semibold" }, " Login and play with Quokka! ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "google-sign-in-logo-background flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://developers.google.com/identity/images/g-logo.png",
    alt: "G",
    class: "google-sign-in-logo"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "google-sign-in-text" }, "Sign in with Google", -1))

import { LoginPageQueryKey, Route } from "@evolutivelabs/quokka-common";
import Button from "primevue/button";
import { useRoute } from "vue-router";
import { config } from "@/config";
import {
  LoginApiQuery,
  API_ROOT,
  ApiRoute,
} from "@evolutivelabs/quokka-common";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const login = () => {
  const redirectPath = route.query[LoginPageQueryKey.RedirectPath];
  let query: LoginApiQuery;
  if (typeof redirectPath === "string") {
    query = new LoginApiQuery(redirectPath);
  } else {
    query = new LoginApiQuery(Route.Dashboard);
  }
  window.location.href = `/${API_ROOT}/${ApiRoute.Auth}/google?${query}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(config).LOGO,
      alt: "Quokka"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createVNode(_unref(Button), {
      onClick: login,
      class: "p-button-lg google-sign-in-button"
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    })
  ]))
}
}

})